@if (isVisible && qrCode) {
    <div id="container-qr-code">
        <div id="qr-code">
            <span class="close-icon" aria-hidden="true" (click)="close()">&times;</span>
            <div class="row w-100 pl-3 pb-3">
                <div class="bold-text blue-color text-center w-100 pb-3 nudge-right">QR CODE DE VOTRE eSIM</div>
                <div class="col-12">
                    <div class="important">
                        <strong>Une même eSIM peut être utilisée jusqu’à 5 activations maximum.</strong>
                    </div>
                    <br/>
                    Si des données sont enregistrées sur votre carte SIM ou eSIM actuelle, <strong>il faut les
                    sauvegarder avant d’activer cette eSIM.</strong>
                    <br/><br/>
                    Pour télécharger l’eSIM sur votre smartphone, suivez ces étapes :<br/>
                    <div class="ml-2 mb-2">
                        - Vérifiez que votre téléphone a accès à Internet (via un réseau WiFi ou une autre carte SIM)
                        <br/>
                        - Scannez le QR code ci-dessous en utilisant l’appareil photo de votre smartphone (affichez-le
                        sur un ordinateur, un autre téléphone ou une tablette ou imprimez-le)
                        <br/>
                        <div class="w-100 text-center mb-2 mt-2">
                            <a download="{{phoneNumber + '_eSim.png'}}" href="{{qrCodeImage}}"><img [src]="qrCodeImage"
                                                                                                    width="120"/></a>
                            <br/>
                            <a download="{{phoneNumber + '_eSim.png'}}" href="{{qrCodeImage}}">Cliquez ici</a> pour
                            télécharger ce QR code
                        </div>
                        <div class="mb-3 ml-2">Si vous n’arrivez pas à le scanner, saisissez ce code sur votre mobile:
                            <br/> <span class="bold-text">{{ qrCode }}</span></div>
                        - Cliquez sur “Ajouter un nouveau forfait” ou “Enregistrer le profil eSIM” puis sur “Activer le
                        nouveau forfait”.
                        <br/>
                        - Saisissez le code PIN 0000 si c’est la 1ère utilisation de cette eSIM, ou votre code PIN
                        habituel si vous l’avez personnalisé.
                        <br/>
                        - Redémarrez votre téléphone puis, si vous ne l’avez pas encore fait, personnalisez le code PIN
                        de l’eSIM pour la sécuriser.
                    </div>
                    <strong>
                        Vous pourrez utiliser votre ligne {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }}
                        dans l’heure qui suit l’enregistrement de l’eSIM sur votre smartphone, ou au moment de son
                        activation chez {{ brand | titlecase }} en cas de portabilité.
                    </strong>
                    <br/><br/>
                    Les réglages dépendent de votre téléphone. N’hésitez pas à lire son mode d'emploi.
                    <br/><br/>
                    Si vous supprimez le profil eSIM (ou forfait cellulaire) de votre téléphone, vous ne pourrez plus
                    utiliser votre ligne mobile {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }}. Il faudra
                    re-télécharger l'eSIM en scannant son QR code.
                    <br/><br/>
                    Si vous changez de téléphone, effacez le profil eSIM de votre ancien mobile avant de le télécharger
                    sur votre nouveau smartphone.
                </div>
                <div class="text-center w-100">
                    <button type="button" class="cta_btn level_2" (click)="close()">Fermer<span></span></button>
                </div>
            </div>
        </div>
    </div>
}
